import isString from 'lodash/isString';
export const isEmail = value => {
  const emailRegex = new RegExp(
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ //eslint-disable-line
  );
  return emailRegex.test(value);
};

export const getBoolean = value => (isString(value) ? value === 'true' : value);

// ---------------------------------------------------------------------------
// Shared client-side rules for entity Name / Code fields (stores, zones,
// concepts, tills, brands, categories, attributes, SKUs, labels, collections).
// Single source so every create/edit form and drawer validates identically.
//
// Name — no character restriction; max 100 characters.
// Code — Unicode letters/marks/numbers plus '_' and '.' only (no spaces,
//        no other symbols); max 50 characters.
// External IDs — max 255 characters (MAX_EXTERNAL_ID_LENGTH in
//        utils/constants).
// ---------------------------------------------------------------------------
export const NAME_MAX_LENGTH = 100;
export const CODE_MAX_LENGTH = 50;

//   \p{L} letters (any language), \p{M} combining marks, \p{N} numbers.
export const ENTITY_CODE_REGEX = /^[\p{L}\p{M}\p{N}_.]+$/u;

export const NAME_TOO_LONG_MESSAGE = `Name must be ${NAME_MAX_LENGTH} characters or fewer`;
export const CODE_TOO_LONG_MESSAGE = `Code must be ${CODE_MAX_LENGTH} characters or fewer`;
export const ENTITY_CODE_ERROR_MESSAGE =
  'Code can contain letters and numbers; "_" and "." are the only symbols allowed (no spaces)';

// Returns the shared error message for a name, '' when valid. Names carry no
// character restriction — only the length cap. Blank names are handled by each
// form's required-field check.
export const entityNameError = name => {
  const trimmed = (name == null ? '' : String(name)).trim();
  return trimmed.length > NAME_MAX_LENGTH ? NAME_TOO_LONG_MESSAGE : '';
};

// Returns the shared error message for a code, '' when valid. Length is
// checked before the charset so the user sees one issue at a time.
export const entityCodeError = code => {
  const trimmed = (code == null ? '' : String(code)).trim();
  if (!trimmed) return '';
  if (trimmed.length > CODE_MAX_LENGTH) return CODE_TOO_LONG_MESSAGE;
  if (!ENTITY_CODE_REGEX.test(trimmed)) return ENTITY_CODE_ERROR_MESSAGE;
  return '';
};
